<template>
  <div class="inithomework">
    <div class="back"></div>
    <div class="main">
      <div class="main_inner">
        <left-panel></left-panel>
        <div class="right-content">
          <div class="chat-area">
            <chat-top :id="id" @sendhomework="sendhomework" :title="title" :rid="rid" :lessonid="lessonid" :classid="classid" :homeworkid="homeworkid"></chat-top>
            <scroll-wrapper :question="question" :reply="reply" :temp="temp" @deletemessage="deletemessage"></scroll-wrapper>
            <chat-bottom :id="id" :isFirstSent="isFirstSent" @sendmessage="receivemessage"></chat-bottom>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="发送成功"
      :visible.sync="sendShow"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <p style="font-size:20px;line-height:36px;margin-bottom:20px;">您可以使用微信“扫一扫”打开全优在线小程序发送作业给老师</p>
      <img style="display: block;margin: 0 auto;" :src="qrurl" alt="二维码" width="250" height="250">

      <button class="confirm" @click="quitEdit">返回作业管理</button>
    </el-dialog>
    <!--<div class="hint-mask" v-if="sendShow">-->
      <!--<div class="sendhint">-->
        <!--<p class="img-wrapper">-->
          <!--<img src="./success.png" alt="warning" width="50" height="50">-->
        <!--</p>-->
        <!--<p class="send-title">发送成功</p>-->
        <!--<p class="hint-text">敬请等待老师批阅</p>-->
        <!--&lt;!&ndash;<button class="cancel" @click="quitEdit">暂不留</button>&ndash;&gt;-->
        <!--<button class="confirm" @click="quitEdit">知道了</button>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import leftPanel from '@/components/homework/leftpanel'
  import chatTop from '@/components/homework/schattop'
  import scrollWrapper from '@/components/homework/studentscroll'
  import chatBottom from '@/components/homework/studentchatbottom'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        title: '',
        rid: '',
        lessonid: '',
        classid: '',
        homeworkid: '',
        userid: '',
        question: [],    //作业题目
        reply: [],
        temp: [],
        isFirstSent: true,
        sendShow: false,
        qrurl:'',
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      deletemessage(index) {
        if (index == 0) {
          if (this.temp.length > 1) {
            this.temp[1].time = this.temp[0].time;
          } else {
            this.isFirstSent = true;
          }
        }
        this.temp.splice(index, 1);
      },
      receivemessage(value) {
        this.temp.push(value);
        this.isFirstSent = false;
      },
      QueryHomeWorkContent(classid, homeworkid) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryHomeWorkContent',
            id: this.id,
            classid: classid,
            homeworkid: homeworkid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.userid=response.userid;
            let list = response.list[0];
            this.question = this.transform(list.question);
            list.content.forEach((ele)=>{
              if(ele.userid==this.userid){
                this.reply = this.transform(ele.reply)
              }
            })
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      transform(list) {
        try {
          JSON.parse(decodeURIComponent(list))
          return JSON.parse(decodeURIComponent(list))
        }
        catch (err) {
          return []
        }
      },
      quitEdit() {
        this.$router.replace('/account/personal/work')
      },
      goSolution() {
        this.$router.replace(
          {
            path: '/homework/solution',
            query: {
              title: this.title,
              rid: this.rid,
              lessonid: this.lessonid,
              classid: this.classid,
              homeworkid: this.homeworkid
            }
          }
        )
      },
      computeUpList(list) {
        if (this.isEmpty(list)) {
          return '';
        } else {
          let result = JSON.stringify(list);
          result = encodeURIComponent(result);
          return result;
        }
      },
      sendhomework() {
        if (this.computeUpList(this.temp) == '') {
          this.$message({
            message: '请输入回复信息',
            type: 'warning'
          })
          return;
        }
        this.UpdateHomeWorkContent(false);
      },
      UpdateHomeWorkContent() {
        let params = {
          c: 'HomeWork',
          a: 'UpdateHomeWorkContent',
          id: this.id,
          classid: this.classid,
          homeworkid: this.homeworkid,
          studentid: this.userid,
          reply:this.computeUpList(this.temp)
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.GetCWxloginAGetwxqrcode();

            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      GetCWxloginAGetwxqrcode(){
        let params = {
          c: 'WxLogin',
          a: 'getWXQRCode',
          page: 'pages/sharefromweb/sharefromweb',
          scene:this.rid+'-'+this.lessonid+'-'+this.classid+'-'+this.homeworkid
        };

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.sendShow = true;
            this.qrurl=response.QRCode;
          }
        }).catch((err) => {

        });
      }
    },
    created() {
      this.title = decodeURIComponent(this.$utils.getUrlKey('title'));
      this.classid = decodeURIComponent(this.$utils.getUrlKey('classid'));
      this.rid = decodeURIComponent(this.$utils.getUrlKey('rid'));
      this.lessonid = decodeURIComponent(this.$utils.getUrlKey('lessonid'));
      this.homeworkid = decodeURIComponent(this.$utils.getUrlKey('homeworkid'));

      if (this.homeworkid != 'null') {
        this.QueryHomeWorkContent(this.classid, this.homeworkid)
      }
    },
    components: {
      leftPanel,
      chatTop,
      scrollWrapper,
      chatBottom
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .inithomework {
    height: 100%;
    .back {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: url('./background.png') no-repeat 50%;
      background-size: cover;
    }
  }

  .main {
    height: 80%;
    min-height: 600px;
    padding-top: 100px;
    -webkit-transition: padding .3s linear;
    .main_inner {
      max-width: 1000px;
      min-width: 800px;
      height: 100%;
      margin: 0 auto;
      border-radius: 3px;
      overflow: hidden;
      background: #fff
      .right-content {
        height: 100%;
        .chat-area {
          position: relative;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }

  @media (max-height: 800px), (max-width: 1000px) {
    .main {
      padding-top: 0;
      height: 100%;
    }
  }
  .cancel, .confirm {
    display: block;
    margin:20px auto;
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    border-radius: 4px;
  }
  .cancel {
    margin-right: 20px;
    background: #ccc;
  }
  .confirm {
    background: #3399ff;
    &:hover {
      background: #5eaefe
    }
  }
  .hint-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    font-size: 0
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .sendhint {
      display: inline-block;
      padding: 40px 0 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 20px;
        height: 50px;
        text-align: center
      }
      .send-title {
        font-size: 16px;
        color: #333;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      .hint-text {
        margin: 0 70px 20px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .back-btn {
        display: inline-block;
        font-size: 15px;
        color: #fff;
        width: 250px;
        height: 36px;
        line-height: 36px;
        background: #3399ff;
        border-radius: 4px;
        &:hover {
          background: #5eaefe
        }
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/homework/sworkedit/sworkedit.vue